module.exports = __webpack_public_path__ + "f82f674e63128c174e6bf5e0a612fcd9.png";